import template from './object-builder.html';

const objectBuilderDirective = /* @ngInject */ () => ({
	scope: {
		data: '=',
		label: '@',
		tooltipText: '@',
	},
	restrict: 'E',
	template,
	replace: true,
	/**
	 * @param {any} $scope
	 */
	link($scope) {
		const init = () => {
			$scope.data = $scope.data || {};
			$scope.dataArray = [];
			// eslint-disable-next-line guard-for-in
			for (const key in $scope.data) {
				$scope.dataArray.push({
					key,
					value: $scope.data[key],
				});
			}
		};

		init();

		$scope.addValue = () => {
			$scope.dataArray.push({ key: '', value: '' });
		};

		$scope.removeValue = (/** @type {number} */ index) => {
			$scope.dataArray.splice(index, 1);
		};

		if ($scope.dataArray.length === 0) {
			$scope.addValue();
		}

		$scope.$watch('data', init);

		$scope.$watch('dataArray', (/** @type {any} */ newValue) => {
			$scope.data = {};
			// eslint-disable-next-line guard-for-in
			for (const index in newValue) {
				const item = newValue[index];
				$scope.data[item.key] = item.value;
			}
		}, true);
	},
});

export default objectBuilderDirective;
